import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/layouts/DefaultLayout.vue')
const ViewCategoriaProveedor = () => import('./Index')

const router = [
  {
    path: '/',
    component: DefaultContainer,
    children: [
      {
        path: 'categoria_proveedor',
        name: 'Categoria Proveedor',
        component: ViewCategoriaProveedor,
        beforeEnter: Permisos.IS_AUTENTICADO,
      },
    ],
  },
]

export default router
